
import {createComponentSimulation} from '@wixc3/simulation-core';
import {StylableButton} from '../../StylableButton';

export default createComponentSimulation({
  componentType: StylableButton,
  name: 'StylableButtonPreset23',
  readOnly: true,
  props: {
    label: 'Stylable_Button_Settings_ButtonText_Default_Love_Icon',
    svgId: '11062b_89bc069bc92b46fb84563fdb611c4d4f.svg',
  },
});
